import { render, staticRenderFns } from "./catalogue-header.vue?vue&type=template&id=311d8a54&scoped=true&"
import script from "./catalogue-header.vue?vue&type=script&lang=ts&"
export * from "./catalogue-header.vue?vue&type=script&lang=ts&"
import style0 from "./catalogue-header.vue?vue&type=style&index=0&id=311d8a54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d8a54",
  null
  
)

export default component.exports